const pathsMap = {
  production: {
    approval: process.env.REACT_APP_APPROVAL_HOST ?? 'https://approval.api.modusign.co.kr',
    auth: process.env.REACT_APP_AUTH_HOST ?? 'https://auth.api.modusign.co.kr',
    bulkRequest: process.env.REACT_APP_BULK_REQUEST_HOST ?? 'https://bulk-request.api.modusign.co.kr/v1',
    category: process.env.REACT_APP_CATEGORY_HOST ?? 'https://category.api.modusign.co.kr',
    crossCert: process.env.REACT_APP_CROSS_CERT_HOST ?? 'https://cc.api.modusign.co.kr',
    document: process.env.REACT_APP_DOCUMENT_HOST ?? 'https://document.api.modusign.co.kr/v1',
    externalDocument: process.env.REACT_APP_EXTERNAL_DOCUMENT_HOST ?? 'https://external-document.api.modusign.co.kr',
    fileProxy: process.env.REACT_APP_FILE_PROXY_HOST ?? 'https://file-proxy.api.modusign.co.kr',
    form: process.env.REACT_APP_FORM_HOST ?? 'https://form.api.modusign.co.kr',
    identityAccess: process.env.REACT_APP_IDENTITY_ACCESS_HOST ?? 'https://identityaccess.api.modusign.co.kr/v1',
    notification: process.env.REACT_APP_NOTIFICATION_HOST ?? 'https://notification.api.modusign.co.kr/v1',
    payment: process.env.REACT_APP_PAYMENT_HOST ?? 'https://payment.api.modusign.co.kr/v1',
    signature: process.env.REACT_APP_SIGNATURE_HOST ?? 'https://signature-mgmt.api.modusign.co.kr',
    subscription: process.env.REACT_APP_SUBSCRIPTION_HOST ?? 'https://subscription.api.modusign.co.kr/v1',
    template: process.env.REACT_APP_TEMPLATE_HOST ?? 'https://template.api.modusign.co.kr/v1',
  },
  stage: {
    approval: process.env.REACT_APP_APPROVAL_HOST ?? 'https://approval-stage.api.modusign.co.kr',
    auth: process.env.REACT_APP_AUTH_HOST ?? 'https://auth-stage.api.modusign.co.kr',
    bulkRequest: process.env.REACT_APP_BULK_REQUEST_HOST ?? 'https://bulk-request-stage.api.modusign.co.kr',
    category: process.env.REACT_APP_CATEGORY_HOST ?? 'https://category-stage.api.modusign.co.kr',
    crossCert: process.env.REACT_APP_CROSS_CERT_HOST ?? 'https://cc-stage.api.modusign.co.kr',
    document: process.env.REACT_APP_DOCUMENT_HOST ?? 'https://document-stage.api.modusign.co.kr',
    externalDocument: process.env.REACT_APP_EXTERNAL_DOCUMENT_HOST ?? 'https://external-document-stage.api.modusign.co.kr',
    fileProxy: process.env.REACT_APP_FILE_PROXY_HOST ?? 'https://file-proxy-stage.api.modusign.co.kr',
    form: process.env.REACT_APP_FORM_HOST ?? 'https://form-stage.api.modusign.co.kr',
    identityAccess: process.env.REACT_APP_IDENTITY_ACCESS_HOST ?? 'https://user-stage.api.modusign.co.kr',
    notification: process.env.REACT_APP_NOTIFICATION_HOST ?? 'https://notification-stage.api.modusign.co.kr',
    payment: process.env.REACT_APP_PAYMENT_HOST ?? 'https://payment-stage.api.modusign.co.kr',
    signature: process.env.REACT_APP_SIGNATURE_HOST ?? 'https://signature-stage.api.modusign.co.kr',
    subscription: process.env.REACT_APP_SUBSCRIPTION_HOST ?? 'https://subscription-stage.api.modusign.co.kr',
    template: process.env.REACT_APP_TEMPLATE_HOST ?? 'https://template-stage.api.modusign.co.kr',
  }
};

export const paths = pathsMap[process.env.REACT_APP_MODUSIGN_ENV === 'production' ? 'production' : 'stage'];

export const withApproval = (url: string) => `${paths.approval}${url}`;
export const withAuth = (url: string) => `${paths.auth}${url}`;
export const withBulkRequest = (url: string) => `${paths.bulkRequest}${url}`;
export const withCategory = (url: string) => `${paths.category}${url}`;
export const withCrossCert = (url: string) => `${paths.crossCert}${url}`;
export const withDocument = (url: string) => `${paths.document}${url}`;
export const withExternalDocument = (url: string) => `${paths.externalDocument}${url}`;
export const withForm = (url: string) => `${paths.form}${url}`;
export const withIdentityAccess = (url: string) => `${paths.identityAccess}${url}`;
export const withNotification = (url: string) => `${paths.notification}${url}`;
export const withPayment = (url: string) => `${paths.payment}${url}`;
export const withSignature = (url: string) => `${paths.signature}${url}`;
export const withSubscription = (url: string) => `${paths.subscription}${url}`;
export const withTemplate = (url: string) => `${paths.template}${url}`;
export const withUpload = (url: string) => `${paths.fileProxy}${url}`;
